import React, { useEffect, useRef } from 'react'
import useState from 'react-usestateref'

import classNames from 'classnames'

import styles from './testimonial_form.module.sass'

import each from 'lodash/each'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import { last } from 'lodash'

function TestimonialForm(props) {
	const [form, setForm] = useState(null)
	const [formData, setFormData] = useState({})
	const [currentPage, setCurrentPage] = useState(1)
	const [submitted, setSubmitted] = useState(false)
	const formWrapperRef = useRef(null)
	const hasMounted = useRef(false)

	// Fetch form structure
	useEffect(() => {
		async function fetchData() {
			const response = await fetch(`/wp-json/3fo-base/v1/gfform/2`, {
				headers: {
					'Content-Type': 'application/json',
				},
			})

			const responseJson = await response.json()
			setForm(responseJson)
		}

		fetchData()
	}, [])

	// Clear validation errors
	function clearErrors() {
		const errors = [...formWrapperRef.current.querySelectorAll(`.${styles.error}`)]
		errors.map((error) => {
			error.remove()
		})
	}

	// Populate validation errors
	function populateErrors(errorData) {

		if (formWrapperRef.current) {
			//clear existing errors
			const existingErrors = formWrapperRef.current.querySelectorAll(`.${styles.error}`)
			existingErrors.forEach((error) => {
				error.remove()
			})
			
			each(errorData, (value, fieldId) => {
				const error = document.createElement('p')
				error.className = styles.error
				error.textContent = value
	  
				const fieldElement = formWrapperRef.current.querySelector(`[name="input_${fieldId}"], [id="input_${fieldId}"]`)
				if (fieldElement) {
					const fieldContainer = fieldElement.parentNode
					if (fieldContainer) {
						fieldContainer.appendChild(error)
					}
				}
			})
		}
	}

	// Handle input changes
	function handleInputChange(e) {
		let { name, value } = e.target
		let newData = {}
		let parentName = ''


		//if type is checkbox, handle differently
		if (e.target.type === 'checkbox') {
			parentName = e.target.parentNode.parentNode.id

			if(e.target.checked){
				newData[parentName] = value
				newData[name] = value
			} else {
				setFormData((prevData) => {
					const updatedData = { ...prevData }
					delete updatedData[name]
					delete updatedData[parentName]
					return updatedData
				})
				return
			}
		} else {
			newData[name] = value
		}

		setFormData((prevData) => ({
			...prevData,
			...newData
		}))
	}
	

	// Handle form submission
	async function handleSubmit(e) {
		e.preventDefault()

		clearErrors()

		const payload = {
			fields: formData,
			target_page: 0,
		}

		const response = await fetch(`/wp-json/3fo-base/v1/gfform/2`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		})

		const responseJson = await response.json()

		document.getElementById('testimonial_form').scrollIntoView({
			behavior: 'smooth'
		})

		if (responseJson.is_valid) {
			setCurrentPage(currentPage + 1)

			if (responseJson.confirmation_message) {
				setSubmitted(responseJson.confirmation_message)
			} else if (responseJson.confirmation_redirect) {
				window.location = responseJson.confirmation_redirect
			}
		} else {
			// Handle errors
			populateErrors(responseJson.validation_messages)
		}
	}

	async function validatePage(pageIndex, nextPageIndex) {
		clearErrors()

		const payload = {
			fields: formData,
			target_page: nextPageIndex,
			source_page: pageIndex,
		}

		const response = await fetch(`/wp-json/3fo-base/v1/gfform/2`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		})

		const responseJson = await response.json()

		document.getElementById('testimonial_form').scrollIntoView({
			behavior: 'smooth'
		})

		if (responseJson.is_valid) {
			if(nextPageIndex){
				setCurrentPage(nextPageIndex)
			} else {
				if (responseJson.confirmation_message) {
					setSubmitted(responseJson.confirmation_message)
				} else if (responseJson.redirect_url) {
					window.location = responseJson.redirect_url
				}
			}
		} else {
			populateErrors(responseJson.validation_messages)
		}
	}

	// Render current page fields
	function renderFields(fields, currentPage) {
		return fields
			.filter((field) => field.pageNumber === currentPage)
			.map((field) => {
				const {
					id,
					type,
					label,
					labelPlacement,
					subLabelPlacement,
					cssClass,
					placeholder,
					size,
					inputs,
					choices,
					inputType,
					content,
					description,
					isRequired,
					choiceAlignment,
					layoutGridColumnSpan
				} = field
	
				const columnClass = layoutGridColumnSpan ? `col_${layoutGridColumnSpan}` : ''
	
				switch (type) {
					case 'checkbox':
						return (
							<div key={id} id={`input_${id}`} className={classNames(styles.field, styles.checkbox_wrapper, styles[columnClass], styles[cssClass])}>
								{label && <label className={labelPlacement == 'hidden_label' ? styles.hidden : ''}>{label}</label>}
								<div className={styles.checkbox} id={`input_${id}`}>
									{choices.map((choice, index) => (
										<div key={index} className={styles.choice}>
											<input
												type="checkbox"
												name={`input_${id}.${index + 1}`}
												id={`input_${id}_${index + 1}`}
												defaultValue={choice.value}
												checked={formData[`input_${id}.${index + 1}`] ? true : false}
												onChange={handleInputChange}
											/>
											<label htmlFor={`input_${id}_${index + 1}`}>{choice.text}</label>
										</div>
									))}
									{description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }}></div>}
								</div>
							</div>
						)

						case 'multi_choice':
							return (
								<div key={id} className={classNames(styles.field, styles.radio_wrapper, styles[columnClass], styles[cssClass])}>
									<label className={labelPlacement == 'hidden_label' ? styles.hidden : ''}>{label}</label>
									<div className={classNames(styles.radio, styles[choiceAlignment])} id={`input_${id}`}>
										{choices.map((choice, index) => (
											<div key={index} className={styles.choice}>
												<input
													type="radio"
													name={`input_${id}`}
													id={`input_${id}_${index + 1}`}
													defaultValue={choice.value}
													checked={formData[`input_${id}`] === choice.value}
													onChange={handleInputChange}
												/>
												<label htmlFor={`input_${id}_${index + 1}`}>{choice.text}</label>
											</div>
										))}
									</div>
									<div className={styles.description} dangerouslySetInnerHTML={{ __html: description }}></div>
								</div>
							)
	
					case 'html':
						return (
							<div
								key={id}
								className={`field ${styles.html} ${styles[columnClass]} ${cssClass || ''}`}
								dangerouslySetInnerHTML={{ __html: content }}
							></div>
						)
	
					case 'textarea':
						return (
							<div key={id} className={classNames(styles.field, styles.textarea, styles[columnClass], styles[cssClass])}>
								<label className={labelPlacement == 'hidden_label' ? styles.hidden : ''} htmlFor={`input_${id}`}>{label}</label>
								<textarea
									name={`input_${id}`}
									id={`input_${id}`}
									placeholder={placeholder}
									className={size === 'large' ? 'large' : ''}
									onChange={handleInputChange}
									defaultValue={formData[`input_${id}`] || ''}
								/>
							</div>
						)
	
					case 'page':
						return false
						// (
						// 	<div key={id} className={`field page ${columnClass} ${cssClass || ''}`}>
						// 		{/* Handle Next/Previous buttons here */}
						// 		<button type="button" onClick={handlePreviousPage}>
						// 			{field.previousButton?.text || 'Previous'}
						// 		</button>
						// 		<button type="button" onClick={handleNextPage}>
						// 			{field.nextButton?.text || 'Next'}
						// 		</button>
						// 	</div>
						// )
	
					case 'name':
						return (
							<div key={id} className={classNames(styles.field, styles.name, styles[columnClass], styles[cssClass])}>
								<label>{label}{isRequired && '*'}</label>
								<div id={`input_${id}`} className={styles.name_wrapper}>
									{inputs.map((input) => {
										if (['First', 'Last'].includes(input.label)) {
											return (
												<div key={input.id} className={styles.sub_name}>
													<label className={subLabelPlacement == 'hidden_label' ? styles.hidden : ''} htmlFor={`input_${input.id}`}>{input.label}</label>
													<input
														type="text"
														name={`input_${input.id}`}
														id={`input_${input.id}`}
														autoComplete={input.autocompleteAttribute}
														placeholder={input.label}
														value={formData[`input_${input.id}`] || ''}
														onChange={handleInputChange}
													/>
												</div>
											)
										}
										return null
									})}
								</div>
							</div>
						)
	
					case 'email':
						return (
							<div key={id} className={classNames(styles.field, styles.email, styles[columnClass], styles[cssClass])}>
								<label htmlFor={`input_${id}`}>{label}{isRequired && '*'}</label>
								<input
									type="email"
									name={`input_${id}`}
									id={`input_${id}`}
									placeholder={placeholder}
									value={formData[`input_${id}`] || ''}
									onChange={handleInputChange}
								/>
							</div>
						)
	
					case 'phone':
						return (
							<div key={id} className={classNames(styles.field, styles.phone, styles[columnClass], styles[cssClass])}>
								<label htmlFor={`input_${id}`}>{label}{isRequired && '*'}</label>
								<input
									type="tel"
									name={`input_${id}`}
									id={`input_${id}`}
									placeholder={placeholder}
									autoComplete="tel"
									value={formData[`input_${id}`] || ''}
									onChange={handleInputChange}
								/>
							</div>
						)
	
					default:
						return null
				}
			})
	}	

	// Handle page navigation
	function handleNextPage() {
		if(currentPage == form?.pagination?.pages?.length){
			validatePage(currentPage, null)
		} else {
			validatePage(currentPage, currentPage + 1)
		}
	}

	function handlePreviousPage() {
		setCurrentPage((prevPage) => prevPage - 1)
	}

	useEffect(() => {
		if (hasMounted.current) {
			// Scroll to the element after the page change
			const element = document.getElementById('testimonial_form')
			if (element) {
				element.scrollIntoView({
					behavior: 'smooth',
				})
			}
		} else {
			hasMounted.current = true
		}
	}, [currentPage])

	const isLastPage = currentPage === form?.pagination?.pages?.length
	const isFirstPage = currentPage === 1
	const progressPercentage = ((currentPage - 1) / form?.pagination?.pages?.length) * 100

	return (
		<BlockWrapper {...props} className={styles.testimonial_form} id="testimonial_form">
			<ScrollAnimation styles={styles}>
				{submitted && <div className={styles.confirmation} dangerouslySetInnerHTML={{ __html: submitted }}></div>}
				{!submitted && (
					<div ref={formWrapperRef} className={styles.form}>
						{form && (
							<>
							{/* Progress Bar */}
							<div className={styles.progress_bar_wrapper}>
								<div className={styles.progress_line}>
									{/* Progress Indicator */}
									<div
										className={styles.progress_fill}
										style={{ width: `${progressPercentage}%` }}
									></div>
								</div>
								{/* Steps */}
								<div className={styles.steps}>
									{form.pagination.pages.map((page, index) => {
										if(form?.pagination?.pages?.[index] == " "){
											return false
										}
										
										return (
										<div
											key={index}
											className={`${styles.step} ${
												index == currentPage-1 ? styles.active : '' || index < currentPage-1 ? styles.complete : ''
											}`}
										>
											<div className={styles.step_status}>
												<span className={styles.index}>{index + 1}</span>
											</div>
											<div className={styles.step_label}>
												<span className={styles.step_eyebrow}>Step {index + 1}</span>
												<span className={styles.step_title}>{form?.pagination?.pages?.[index]}</span>
											</div>
										</div>
										)
									})}
								</div>
							</div>

							{/* Form Fields */}
							<form onSubmit={handleSubmit} className={isLastPage ? styles.last_page : ''}>
								<div className={styles.fields}>
									{renderFields(form.fields, currentPage)}
									{isLastPage && <div className={styles.submit_wrapper}>
										<button type="submit" className={styles.submit}>Submit</button>
									</div>
									}
								</div>
								{currentPage <= form?.pagination?.pages?.length && (
									<div className={styles.pagination}>
										{
											<div className={styles.pagination_buttons}>
												<button className={styles.previous} disabled={currentPage === 1} type="button" onClick={handlePreviousPage}>
													Previous
												</button>
												<button className={styles.next} disabled={isLastPage}  type="button" onClick={handleNextPage}>
													Next
												</button>
											</div>
										}
									</div>
									
								)}
							</form>
							</>
						)}
					</div>
				)}
			</ScrollAnimation>
		</BlockWrapper>
	)
}

export default TestimonialForm